module.exports = __webpack_public_path__ + "icon-marker-red.svg?1644e7ed7ea14c0028f8b766c0f6e8a4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon-marker-red.svg
// module id = 33
// module chunks = 0